<template>
    <div>
        <kgr-loader inline v-if="loading" />
        <table>
            <tr v-for="receiver in receiverList" :key="receiver.id" class="receiver" :class="bounce(receiver)">
                <td>{{ receiver.name }}</td>
                <td>{{ receiver.email }}</td>
            </tr>
        </table>
    </div>
</template>
<script>

import Loader from '../common/Loading.vue';
import axios from 'axios';

export default {
    components: {
        'kgr-loader': Loader,
    },
    props: {
        mailHistoryId: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            receiverList: [],
            loading: true,
        }
    },
    methods: {
        bounce(receiver) {
            return receiver.isBounced ? 'bounced' : '';
        },
    },
    created() {
        axios
            .get(`/mail-history/${this.mailHistoryId}/receivers`)
            .then(response => {
                this.receiverList = response.data.data
                this.loading = false;
            })
            .catch(() => this.$notify.error('saveChanges.error'));
    }
}
</script>


<style scoped lang="scss" rel="stylesheet/scss">
.receiver {
    padding: 0 5px;
}
.bounced {
    background-color: #ff9800;
}
.receiver td:first-child {
    padding-right: 20px;
}
</style>
